import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';
import { CloseIcon } from '../../icons';

const Chip = ({ label, onDelete }) => (
  <span className="chip">
    <span>{label}</span>
    {onDelete && <CloseIcon className="delete-icon" width={16} height={16} onClick={onDelete} />}
  </span>
);

Chip.propTypes = {
  label: PropTypes.string.isRequired,
  onDelete: PropTypes.func
};

export default Chip;
